import React from "react";
import {Spinner} from "@cjdev-internal/visual-stack-x/Spinner";
import "./LoadPage.css"
export function LoadPage() {
    return(
        <div className="parent-container">
            <Spinner size="extra-large" />
        </div>);
}